// extracted by mini-css-extract-plugin
export default {"section":"NoHealthQuestions_section__l1VMj"};